import React, { useState , useEffect } from 'react';
import { useQuery , useMutation } from '@apollo/react-hooks';
import { createApolloFetch } from 'apollo-fetch';
import { Skeleton } from '@material-ui/lab';
import Pusher from 'pusher-js';

import AllMessages from './all-messages.component';
import MessageHeader from './message.header.component';
import MessageContent from './message.content.component';
import MessageFooter from './message.footer.component';
import {GET_ALL_CONVERSATION , CONVERSATION_READ} from './apis';

import './index.style.css';

export default function Index(){
    const { loading, error, data , refetch } = useQuery(GET_ALL_CONVERSATION );
    const [ flag, setFlag ] = useState(0);
    const [messageRead, { res }] = useMutation(CONVERSATION_READ);
    const [activeMessages , setActiveMessages] = useState();
    const [user , setUser] = useState();
    const userAuth = JSON.parse(localStorage.getItem('jwt'));

    
    useEffect(()=>{
        refetch();
        if(activeMessages){
           let updatedMessages = data.conversationAll?.data.filter(conversation => conversation.id === activeMessages[0].id);
           setActiveMessages(updatedMessages);
        }
    },[data]);
    // Pusher.logToConsole = true;
    const pusher = new Pusher('websocket',{
        wsHost       : 'spreago.black-squares.com' ,
        wssPort      : '6001' ,
        authEndpoint : 'https://spreago.black-squares.com/api/authEndpoint' ,
        forceTLS     : false             ,
        disableStats : true              ,
        auth: {
            headers: {
            'authorization': `Bearer ${userAuth.BearerTokenResponse?.access_token}`
            }
        }
    });
    var channel = pusher.subscribe(`private-App.Models.User.${userAuth.user?.id}`);
    channel.bind('NewMassage', (res)=> {
        setFlag(1);
    });
    if(flag === 1){
        refetch();
    }
    // const fetchData = () => {
    //     if (localStorage.jwt) {
    //         //handle fetch specialities and tags dropdown   
    //         const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
    //         const uri = 'https://spreago.black-squares.com/graphql';
    //         const id = JSON.parse(localStorage.jwt).user.id;
    //         const apolloFetch = createApolloFetch({ uri });
    //         apolloFetch.use(({ request, options }, next) => {
    //             if (!options.headers) {
    //                 options.headers = {};  // Create the headers object if needed.
    //             }
    //             options.headers['authorization'] = `Bearer ${token}`;

    //             next();
    //         });
    //         //get user data
    //         apolloFetch({
    //             query:`query{
    //                 conversationAll{
    //                   data{
    //                     id
    //                     user{id name email profile_image{url} }
    //                     company{id name logo{url}}
    //                     CountUnReadMessages
    //                     messages(first : 1000){data{
    //                       id
    //                       user{id name email}
    //                       text
    //                       created_at
    //                     }}
    //                   }
    //                 }
    //               }`
    //         }).then(res => {
    //             console.log(res.data.conversationAll);
    //         });

    //     }
    // }
    if(error) return `Error! ${error.message}`;
    const handleMessageClick = (id) =>{

        messageRead({ variables: { id : id} });
        if(id){
            
            let messages = (data.conversationAll.data.filter(x=> parseInt(x.id) === parseInt(id)));
            setActiveMessages(messages)

            const userAuth = JSON.parse(localStorage.getItem('jwt'))?.user;
            // in case the user is a company
            if (data && userAuth.company) {
                //show the data of user in chat
                setUser(data.conversationAll.data[0].user)
            }
            else {
                setUser(data.conversationAll.data[0].company)
            }   


        }
    }
    if(loading){
        return(
            <div className="container mt-4">
                <Skeleton variant="rect"  height="100vh" />
            </div>
        )
    }
    else{

        return(
            <main className="container  border mt-4">
                <section className="row">
                    <section className="col-md-4 p-0 order-md-1 order-2">
                        <AllMessages handleMessageClick={handleMessageClick} data={data?.conversationAll?.data}/>
                    </section>
                    <section className="col-md-8 p-0 order-md-2 order-1">
                        {/* <MessageHeader  user={user? user : data.conversationAll?.data[0]} />
                        <MessageContent messages={activeMessages? activeMessages[0] : data.conversationAll?.data[0]}/>
                        <MessageFooter sendTo={activeMessages? activeMessages[0].user?.id : data.conversationAll?.data[0].user.id}/> */}
                        <MessageHeader  user={user && user} />
                        <MessageContent messages={activeMessages && activeMessages[0]}/>
                        <MessageFooter sendTo={user && user.id} getData={refetch}/>
                    </section>
                </section>
            </main>
        )
    }
}